import axios from "axios";

export const baseUrl = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL + "/apoteka_rs_server"
  : "https://test.apoteka.rs:8443/apoteka_rs_server";

const instance = axios.create({
  baseURL: baseUrl,
});

instance.defaults.params = {};

/**
 * ITAM-2622 (3.7): a BARE instance — same baseURL, and deliberately NO
 * interceptors. The shared instance's response interceptor fires on any
 * 401/403 and hard-navigates to /auth, which unloads the document and cancels
 * every in-flight request; endpoints that can legitimately reject (the
 * logout-time pause) must not be able to take the page down with them, and
 * must attach their own Authorization header.
 */
export const bareInstance = axios.create({ baseURL: baseUrl });

// Auth error handler - will be initialized after store is available
let handleAuthError: ((error: any) => void) | null = null;

// Function to initialize auth error handler (called from store setup)
export const initializeAuthErrorHandler = (store: any, authActions: any) => {
  handleAuthError = (error: any) => {
    console.error(
      "Auth: Global interceptor detected authentication error, clearing state",
      {
        status: error.response?.status,
        url: error.config?.url,
        error: error.response?.data,
      }
    );

    // Clear auth state
    store.dispatch(authActions.logout());

    // Redirect to auth page if not already there
    if (window.location.pathname !== "/auth") {
      console.log("Auth: Redirecting to auth page due to authentication error");
      window.location.href = "/auth";
    }
  };
};

// Request interceptor to add Authorization header
instance.interceptors.request.use(
  function (config) {
    config.headers.Authorization = "Bearer " + localStorage.getItem("token");
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Response interceptor to handle authentication errors globally
instance.interceptors.response.use(
  // Success response - pass through unchanged
  function (response) {
    return response;
  },
  // Error response - check for auth errors
  function (error) {
    if (error.response?.status === 401 || error.response?.status === 403) {
      if (handleAuthError) {
        handleAuthError(error);
      } else {
        // Fallback if auth error handler not initialized yet
        console.error(
          "Auth: Authentication error detected but handler not initialized",
          {
            status: error.response?.status,
            url: error.config?.url,
          }
        );

        // Simple fallback - just redirect
        if (window.location.pathname !== "/auth") {
          window.location.href = "/auth";
        }
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
